export default __webpack_public_path__ + "static/media/07_DAIF_SUSTAINABILITY_01_loop.903c2259.mp4";